module.exports = __webpack_public_path__ + "static/media/nicolas_gonzalez.6dd5af91.jpg";